import { Button, Popover } from 'antd';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { useWorkOrderComplementSyncWithMyBCS } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.hooks';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';

export default function ComplementMyBCS() {
  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const hasEstimatedLeaveDate = !!complement?.estimatedLeaveDate;
  const isDisabled =
    !hasEstimatedLeaveDate ||
    complement?.status === WorkOrderComplementStatus.Cancelled ||
    complement?.status === WorkOrderComplementStatus.Closed;

  const syncMyBCS = useWorkOrderComplementSyncWithMyBCS();

  const handleSyncMyBCS = async () => {
    if (complement?.id && workorder?.id) {
      await syncMyBCS.mutateAsync({
        complementId: complement.id,
        workOrderId: workorder.id,
      });
    }
  };

  return (
    <Popover
      content={
        !hasEstimatedLeaveDate && (
          <div style={{ maxWidth: 300 }}>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>
                É necessário informar uma data de saída prevista para enviar ao
                MyBCS.
              </li>
            </ul>
          </div>
        )
      }
    >
      <Button
        block
        disabled={isDisabled}
        loading={syncMyBCS.isLoading}
        onClick={handleSyncMyBCS}
      >
        Enviar O.S. para MyBCS
      </Button>
    </Popover>
  );
}
